



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// getAllReapprovalPlansWithCreatorAndRejector
// GETALLREAPPROVALPLANSWITHCREATORANDREJECTOR



const GETALLREAPPROVALPLANSWITHCREATORANDREJECTOR= createAsyncThunk(
  "getAllReapprovalPlansWithCreatorAndRejector/getAllReapprovalPlansWithCreatorAndRejector",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllReapprovalPlansWithCreatorAndRejectorSlice = createSlice({
  name: "getAllReapprovalPlansWithCreatorAndRejectorSlice",
  initialState: {
    getAllReapprovalPlansWithCreatorAndRejector: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllReapprovalPlansWithCreatorAndRejector: (state) => {
        state.getAllReapprovalPlansWithCreatorAndRejector.loading = false
        state.getAllReapprovalPlansWithCreatorAndRejector.error = false
        state.getAllReapprovalPlansWithCreatorAndRejector.data = []
        state.getAllReapprovalPlansWithCreatorAndRejector.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLREAPPROVALPLANSWITHCREATORANDREJECTOR.fulfilled, (state, action) => {
      state.getAllReapprovalPlansWithCreatorAndRejector = {
        ...state.getAllReapprovalPlansWithCreatorAndRejector,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLREAPPROVALPLANSWITHCREATORANDREJECTOR.pending, (state, action) => {
      state.getAllReapprovalPlansWithCreatorAndRejector = {
        ...state.getAllReapprovalPlansWithCreatorAndRejector,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLREAPPROVALPLANSWITHCREATORANDREJECTOR.rejected, (state, action) => {
      state.getAllReapprovalPlansWithCreatorAndRejector = {
        ...state.getAllReapprovalPlansWithCreatorAndRejector,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllReapprovalPlansWithCreatorAndRejectorAction = {
    GETALLREAPPROVALPLANSWITHCREATORANDREJECTOR,
};

export { getAllReapprovalPlansWithCreatorAndRejectorAction };
export default getAllReapprovalPlansWithCreatorAndRejectorSlice.reducer;
export const {setInitialStateOfgetAllReapprovalPlansWithCreatorAndRejector} = getAllReapprovalPlansWithCreatorAndRejectorSlice.actions
